<template>
	<div>
		<div class="videoCon">
			<div class="backBox f-ct" @click="goBack">
				<span>返回课题列表</span>
				<el-image :src="require('@/static/icon75.png')"></el-image>
			</div>
			<div class="videoList">
				<div class="vitm" v-for="(item,index) in videoList">
					<div class="name f-bct" :class="item.isop?'':'a'" @click="statusChange(index)">
						<div class="nameTxt flex">
							<div class="nub">{{index+1}}</div>
							<p>{{item.chapterName}}</p>
						</div>
						<el-image :src="require('@/static/icon87.png')"></el-image>
					</div>
					<div class="clist" v-if="item.isop">
						<div class="itm" @click="selVideo(index,idx)" v-for="(itm,idx) in item.lessonList">
							<template v-if="index==selArr[0]&&idx==selArr[1]">
								<el-image :src="require('@/static/icon89.png')"></el-image>
								<p style="color: #FF5F5A;">{{itm.title}}</p>
							</template>
							<template v-else>
								<el-image v-if="itm.isComplete" :src="require('@/static/icon88.png')"></el-image>
								<el-image v-else :src="require('@/static/icon90.png')"></el-image>
								<p v-if="itm.isComplete" style="color: #3B6492;">{{itm.title}}</p>
								<p v-else>{{itm.title}}</p>
							</template>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="videoBox" v-if="nowVideo">
			<video type="video/mp4" @ended="handleVideoEnded" @pause="zanting" controls controlslist="nodownload" id="myvideo" ref="videoPlayer" :src="nowVideo"></video>
			<!-- <div id="J_prismPlayer"></div> -->
		</div>
		<!-- 提示框 -->
		<div class="maskBg" @click="hbDetail=false" v-if="hbDetail"></div>
		<div class="subTips" v-if="hbDetail">
			<el-image class="cha" @click="hbDetail=false" :src="require('@/static/icon57.png')"></el-image>
			<div class="name">课时介绍</div>
			<div class="detail" v-html="videoMsg.content"></div>
			<div class="btnBox f-ct">
				<div class="b1" @click="hbDetail=false">返回</div>
			</div>
		</div>
	</div>
</template>
<script>
import { courseVideodetail,
courseVideogetPlayInfo,
courseVideogetLearningProgress,
courseVideoaddLearningProgress
} from "/src/api/api.js"
import Aliplayer from 'aliyun-aliplayer';
import 'aliyun-aliplayer/build/skins/default/aliplayer-min.css';
// let playerAl;
import {mapState,mapGetters,mapActions,mapMutations} from 'vuex'
export default {
	data(){
		return {
			hbDetail:false,
			id:0,
			cid:0,
			// 观看进度
			videoJd:'',
			// 详情
			videoMsg:'',
			videoList:[],
			selArr:[0,0],
			nowVideo:'',
			// 当前的时间点是
			currentTime:'',
		}
	},
	mounted() {
		// 参数
		this.id = this.$route.query.id
		this.cid = this.$route.query.cid
		// 获取详情
		this.courseVideogetLearningProgress()
	},
	methods:{
		// 返回
		async goBack(){
			var selArr = this.selArr
			var data = {
				courseOrderId:this.cid,//课程订单ID
				videoId:this.id,//视频ID
				isComplete:'0',//是否观看完成：0-未完成, 1-已完成
				lessonId:this.videoList[selArr[0]].lessonList[selArr[1]].id,//视频章-节ID
				progress:this.currentTime,//观看进度(秒)
			}
			let res = await courseVideoaddLearningProgress(data);
			// if(res.code==200){
				this.back()
			// }else{this.Tips(res.msg,'error')}
		},
		// 切换视频播放
		async selVideo(index,idx){
			var selArr = this.selArr
			var data = {
				courseOrderId:this.cid,//课程订单ID
				videoId:this.id,//视频ID
				isComplete:'0',//是否观看完成：0-未完成, 1-已完成
				lessonId:this.videoList[selArr[0]].lessonList[selArr[1]].id,//视频章-节ID
				progress:this.currentTime,//观看进度(秒)
			}
			let res = await courseVideoaddLearningProgress(data);
			this.videoList.forEach((item)=>{
				item.lessonList.forEach((itm)=>{
					if(res.lessonId==itm.id){
						itm.progress = res.progress
						itm.isComplete = res.isComplete
					}
				})
			})
			// if(res.code==200){
				this.selArr = [index,idx]
				this.courseVideogetPlayInfo()
			// }else{this.Tips(res.msg,'error')}
		},
		// 视频暂停
		async zanting(){
			var selArr = this.selArr
			var data = {
				courseOrderId:this.cid,//课程订单ID
				videoId:this.id,//视频ID
				isComplete:'0',//是否观看完成：0-未完成, 1-已完成
				lessonId:this.videoList[selArr[0]].lessonList[selArr[1]].id,//视频章-节ID
				progress:this.currentTime,//观看进度(秒)
			}
			let res = await courseVideoaddLearningProgress(data);
			this.videoList.forEach((item)=>{
				item.lessonList.forEach((itm)=>{
					if(res.lessonId==itm.id){
						itm.progress = res.progress
						itm.isComplete = res.isComplete
					}
				})
			})
			// this.videoJd.forEach((item)=>{
			// 	if(item.id==res.id){
			// 		item = {...res}
			// 	}
			// })
			// if(res.code==200){
				
			// }else{this.Tips(res.msg,'error')}
		},
		//设置播放点，续播
		playBySeconds (num) {
		    if (num && document.getElementById ('myvideo')) {
		        let myVideo = document.getElementById ('myvideo');
		        myVideo.currentTime = num;
		        // myVideo.play();
				// this.$refs.videoPlayer.play();
				this.getVideoTime()
		    }
		},
		/*** 获取视频播放时长 */
		getVideoTime(){
			var that = this
		    if (document.getElementById ('myvideo')) {
		        let videoPlayer = document.getElementById ('myvideo');
		        videoPlayer.addEventListener('timeupdate', function () {
					// console.log(`当前的时间点是${videoPlayer.currentTime},视频长度是${videoPlayer.duration}`);
					that.currentTime = videoPlayer.currentTime
				}, false)
		    }
		},
		// 视频播放结束
		handleVideoEnded(e){
			// console.log(e)
			this.courseVideoaddLearningProgress()
		},
		// 4.写入观看进度
		async courseVideoaddLearningProgress(){
			var selArr = this.selArr
			var data = {
				courseOrderId:this.cid,//课程订单ID
				videoId:this.id,//视频ID
				isComplete:1,//是否观看完成：0-未完成, 1-已完成
				lessonId:this.videoList[selArr[0]].lessonList[selArr[1]].id,//视频章-节ID
				progress:this.currentTime,//观看进度(秒)
			}
			let res = await courseVideoaddLearningProgress(data);
			this.videoList.forEach((item)=>{
				item.lessonList.forEach((itm)=>{
					if(res.lessonId==itm.id){
						itm.progress = res.progress
						itm.isComplete = res.isComplete
					}
				})
			})
			// if(res.code==200){
				var videoList = this.videoList
				var index = this.selArr[0];
				var idx = this.selArr[1];
				var nextSel = []
				if((videoList[index].lessonList.length-1)==idx){
					if((videoList.length-1)==index){
						
					}else{
						nextSel = [index*1+1,0]
					}
				}else{
					nextSel = [index,idx*1+1]
				}
				if(nextSel.length){
					this.selArr = nextSel
					this.courseVideogetPlayInfo()
					// console.log(nextSel)
				}
			// }else{this.Tips(res.msg,'error')}
		},
		// 3.获取视频
		async courseVideogetPlayInfo(){
			var selArr = this.selArr
			this.nowVideo = []
			let res = await courseVideogetPlayInfo({
				videoId:this.id,
				courseOrderId:this.cid,
				lessonId:this.videoList[selArr[0]].lessonList[selArr[1]].id
			});
			if(res.code==200){
				if(res.data.playUrlList){
					this.nowVideo = res.data.playUrlList[0]
				}
				var itm = this.videoList[selArr[0]].lessonList[selArr[1]]
				// console.log(itm)
				this.playBySeconds(itm.progress)
				// playerAl.dispose()
				// playerAl = new Aliplayer({
				// 	id: "J_prismPlayer",
				// 	license: {
				// 		// 使用在准备工作中获取到的网站域名domain和License Key
				// 		domain: "example.com", // 申请 License 时填写的域名
				// 		key: "example-key" // 申请成功后，在控制台可以看到 License Key
				// 	},
				// 	source: res.data.playUrlList[0], // 播放地址，可以是第三方点播地址，或阿里云点播服务中的播放地址。
				// },
				// function (player) {
				// 	// console.log("The player is created.");
				// 	// player.seek('10')
				// });
			}else{this.Tips(res.msg,'error')}
		},
		// 切换收缩
		statusChange(index){
			var item = this.videoList[index]
			item.isop = !item.isop
			this.$set(this.videoList,index,item)
		},
		// 获取详情
		async courseVideodetail(){
			let res = await courseVideodetail({courseOrderId:this.cid,videoId:this.id});
			if(res.code==200){
				this.videoMsg = res.data
				res.data.chapterList.forEach((item)=>{
					item.isop = true
					item.lessonList.forEach((itm)=>{
						itm.progress = 0
						itm.isComplete = 0
						// console.log(itm)
						for(var i in this.videoJd){
							if(this.videoJd[i].lessonId==itm.id){
								itm.progress = this.videoJd[i].progress
								itm.isComplete = this.videoJd[i].isComplete
							}
						}
					})
				})
				
				var isComplete = 1;
				var selArr = [];
				res.data.chapterList.forEach((item,index)=>{
					item.lessonList.forEach((itm,idx)=>{
						if(isComplete){
							if(!itm.isComplete){
								selArr = [index,idx]
								isComplete = 0
							}
						}
					})
				})
				this.selArr = selArr
				this.videoList = res.data.chapterList
				this.courseVideogetPlayInfo()
			}else{this.Tips(res.msg,'error')}
		},
		// 5.获取观看进度
		async courseVideogetLearningProgress(){
			let res = await courseVideogetLearningProgress({videoId:this.id});
			if(res.code==200){
				this.videoJd = res.data
				this.courseVideodetail()
			}else{this.Tips(res.msg,'error')}
		},
	},
	computed:{
		...mapState('userMsg',['userInfo']),
	}
}
</script>
<style lang="scss">
body{
	// background: #f6f7fb;
}
video::-webkit-media-controls-timeline {
	display: none;
}
video::-moz-progress-bar {
	display: none;
}
video::-ms-track {
	display: none;
}
</style>
<style lang="scss" scoped>
.videoCon{
	width: 360px;
	position: fixed;
	left: 0;
	top: 0;
	height: 100%;
	background: #fff;
	.backBox{
		width: 100%;
		height: 65px;
		background: #3B6492;
		cursor: pointer;
		span{
			font-size: 16px;
			color: #fff;
		}
		.el-image{
			width: 18px;
			height: 18px;
			margin-left: 6px;
		}
		justify-content: center;
	}
	.videoList{
		background: #fff;
		padding-top: 22px;
		height: calc(100% - 85px);
		// background: pink;
		overflow: scroll;
		.vitm{
			margin-bottom: 20px;
		}
		.a{
			background: #F5F8FF;
			.el-image{
				transform: rotate(90deg);
			}
		}
		.name{
			// height: 40px;
			padding-bottom: 22px;
			padding-left: 20px;
			padding-right: 18px;
			cursor: pointer;
			font-size: 16px;
			font-weight: bold;
			align-items: flex-start;
			padding-top: 22px;
			.nameTxt{
				width: calc(100% - 22px);
				.nub{
					width: 30px;
					height: 30px;
					border-radius: 50%;
					text-align: center;
					line-height: 28px;
					border: 1px solid #373D50;
					margin-right: 10px;
				}
				p{
					width: calc(100% - 40px);
					line-height: 25px;
				}
			}
			.el-image{
				width: 12px;
				height: 12px;
				transition:0.3s;
				margin-top: 6px;
			}
		}
		.clist{
			.itm{
				color: #545964;
				font-size: 14px;
				padding-bottom: 26px;
				padding-left: 25px;
				margin-left: 35px;
				padding-right: 18px;
				border-left: 1px solid #BCBFCC;
				position: relative;
				cursor: pointer;
				&:last-child{
					border: none;
				}
				.el-image{
					width: 16px;
					height: 16px;
					position: absolute;
					left: 0;
					transform: translateX(-8px);
					background: #fff;
				}
				p{
					transform: translateY(-2px);
				}
			}
		}
	}
}
.videoBox{
	width: calc(100% - 360px);
	// margin-left: 360px;
	height: 100%;
	position: fixed;
	right: 0;
	top: 0;
	// background: pink;
	padding: 24px;
	video{
		width: 100%;
		height: 100%;
	}
}
.maskBg{
	position: fixed;
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	background: rgba(0, 0, 0, 0.4);
	z-index: 10;
}
.subTips{
	position: fixed;
	width: 420px;
	// height: 364px;
	padding-bottom: 34px;
	background: #fff;
	border-radius: 8px;
	z-index: 11;
	top: 50%;
	left: 50%;
	transform: translateX(-50%)translateY(-50%);
	.cha{
		position: absolute;
		right: 20px;
		top: 20px;
		width: 14px;
		height: 14px;
	}
	.name{
		font-size: 18px;
		font-weight: bold;
		text-align: center;
		padding-top: 32px;
		padding-bottom: 18px;
	}
	.detail{
		width: 379px;
		height: 290px;
		margin: auto;
		border-radius: 2px;
		background: #F7F9FA;
		overflow-y: scroll;
		font-size: 14px;
		color: #7D7D89;
		padding: 16px 12px;
	}
	.btnBox{
		margin-top: 28px;
		justify-content: center;
		div{
			width: 162px;
			height: 46px;
			border-radius: 6px;
			text-align: center;
			line-height: 46px;
			font-size: 16px;
			cursor: pointer;
		}
		.b1{
			background: #E9F6FF;
			color: #3B6492;
		}
		.b2{
			background: #3B6492;
			color: #fff;
			margin-left: 14px;
		}
	}
}
</style>